import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-statistics",
  "use": "icon-statistics-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-statistics\"><path d=\"M550.202472 498.862764h475.124166c0-267.769508-210.606682-485.749008-475.124166-498.862764z\" p-id=\"17369\" /><path d=\"M500.130701 573.882369a25.076976 25.076976 0 0 1-25.006535-25.006535V25.006535C210.606682 38.120291 0 256.064571 0 523.869299c0 276.210681 223.92002 500.130701 500.130701 500.130701 259.328335 0 472.506111-197.399005 497.606567-450.117631z\" p-id=\"17370\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/statistics.svg
// module id = 2O5N
// module chunks = 42